import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NotApplicableCriteriaService } from '../../services/not-applicable-criteria.service';
import { NOT_APPLICABLE_CRITERIA_API_ACTIONS } from '../actions/not-applicable-criteria.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class NotApplicableCriteriaEffects {
  constructor(
    private readonly actions: Actions,
    private readonly notApplicableCriteriaService: NotApplicableCriteriaService,
  ) {}

  getNotApplicableCriteriaExamples$ = createEffect(() =>
    this.actions.pipe(
      ofType(NOT_APPLICABLE_CRITERIA_API_ACTIONS.get),
      switchMap(() =>
        this.notApplicableCriteriaService.getNotApplicableCriteriaExamples().pipe(
          map((data) => NOT_APPLICABLE_CRITERIA_API_ACTIONS.success({ data })),
          catchError((err: HttpErrorResponse) => of(NOT_APPLICABLE_CRITERIA_API_ACTIONS.error(err))),
        ),
      ),
    ),
  );
}
